module.exports = __webpack_public_path__ + "media/images/game_icon/zh-tw/VGPHOENIX-965e2c520992085cc54801b1aa532361.png";